"use client";

import {
  LuBitcoin,
  LuCoins,
  LuRepeat,
  LuScale,
  LuSend,
  LuUser,
  LuWallet,
} from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { Button } from "@/components/ui/button";
import { DESO_TOKEN_NAME } from "@/utils/constants";
import { DIALOG } from "@/utils/dialog-routes";
import { pluralize } from "@/utils/helpers";

export const WalletRebalanceActions = () => {
  return (
    <div className="mb-12 text-muted">
      <div className="w-full">
        <div className="mb-4 w-full">
          <h3 className="flex items-center">
            <LuScale className="mr-2 text-xl" />
            Re-balance Holdings
          </h3>
        </div>
        <div
          className="
            grid grid-cols-2 gap-4
            md:grid-cols-4
            lg:grid-cols-2
            xl:grid-cols-4
          "
        >
          <div
            className="
              m-auto flex size-full flex-col items-center gap-3 rounded-2xl
              border p-6 text-center
              hover:border-card hover:bg-card
            "
          >
            <LuCoins className="size-8" strokeWidth={1} />
            <h2 className="text-sm font-medium text-muted-foreground">
              Top-Up Your Wallet
            </h2>
            <Button
              variant="default"
              size="sm"
              className="mt-1 flex items-center justify-end gap-1"
              onClick={() => {
                setDialog(DIALOG.WalletTopUp, {
                  open: true,
                });
              }}
            >
              <LuBitcoin className="text-base" />
              Top Up
            </Button>
          </div>
          <div
            className="
              m-auto flex size-full flex-col items-center gap-3 rounded-2xl
              border p-6 text-center
              hover:border-card hover:bg-card
            "
          >
            <LuRepeat className="size-8" strokeWidth={1} />
            <h2 className="text-sm font-medium text-muted-foreground">
              Swap{" "}
              {pluralize(Infinity, DESO_TOKEN_NAME, {
                includeCount: false,
              })}
            </h2>
            <Button
              variant="default"
              size="sm"
              className="mt-1 flex items-center justify-end gap-1"
              onClick={() => {
                setDialog(DIALOG.WalletSwap, {
                  open: true,
                });
              }}
            >
              <LuRepeat className="text-base" />
              Swap
            </Button>
          </div>
          <div
            className="
              m-auto flex size-full flex-col items-center gap-3 rounded-2xl
              border p-6 text-center
              hover:border-card hover:bg-card
            "
          >
            <LuWallet className="size-8" strokeWidth={1} />
            <h2 className="text-sm font-medium text-muted-foreground">
              Cash-out to USDC-ERC20
            </h2>
            <Button
              variant="default"
              size="sm"
              className="mt-1 flex items-center justify-end gap-1"
              onClick={() => {
                setDialog(DIALOG.WalletCashOut, {
                  open: true,
                });
              }}
            >
              <LuWallet className="text-base" />
              Cash-out
            </Button>
          </div>
          <div
            className="
              m-auto flex size-full flex-col items-center gap-3 rounded-2xl
              border p-6 text-center
              hover:border-card hover:bg-card
            "
          >
            <LuUser className="size-8" strokeWidth={1} />
            <h2 className="text-sm font-medium text-muted-foreground">
              Send to Wallet/User
            </h2>
            <Button
              variant="default"
              size="sm"
              className="mt-1 flex items-center justify-end gap-1"
              onClick={() => {
                setDialog(DIALOG.WalletSend, {
                  open: true,
                });
              }}
            >
              <LuSend className="text-base" />
              Send
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
